import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ButtonModule } from '../button/button.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
  declarations: [BreadcrumbComponent],
  imports: [CommonModule, SvgIconModule, ButtonModule, RouterLink],
  exports: [BreadcrumbComponent]
})
export class BreadcrumbModule {}

export * from './breadcrumb.component';
